module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"parish":"Parish","subcounties":"Subcounty","profession":"Primary Income","transport":"Transport","isAnAgent":"Is an Agent","isNotAnAgent":"Is NOT an Agent","isAVA":"Is a village ambassador","isNotAVA":"Is NOT a Village Ambassador"},"es":{},"sw":{}}')
  delete Component.options._Ctor
}
